import gatsbyDeployToMain from "../../../../src/images/gatsby/gatsby_deploy_to_main.png";
import gatsbyDeploySelectGhpages from "../../../../src/images/gatsby/gatsby_deploy_select_ghpages.png";
import gatsbyGithubAction1 from "../../../../src/images/gatsby/gatsby_github_action1.png";
import gatsbyGithubSettings from "../../../../src/images/gatsby/gatsby_github_settings.png";
import gatsbyGithubDeveloperSettings from "../../../../src/images/gatsby/gatsby_github_settings_developer_settings.png";
import gatsbyGithubGetPAT1 from "../../../../src/images/gatsby/gatsby_github_get_pat1.png";
import gatsbyGithubGetPAT2 from "../../../../src/images/gatsby/gatsby_github_get_pat2.png";
import gatsbyGithubGetPAT3 from "../../../../src/images/gatsby/gatsby_github_get_pat3.png";
import gatsbyGithubGetPAT4 from "../../../../src/images/gatsby/gatsby_github_get_pat4.png";
import gatsbyGithubGetPAT5 from "../../../../src/images/gatsby/gatsby_github_get_pat5.png";
import gatsbyGithubDeployYml from "../../../../src/images/gatsby/gatsby_github_deploy_yml.png";
import gatsbyGithubAutoDeploy from "../../../../src/images/gatsby/gatsby_github_auto_deploy.png";
import * as React from 'react';
export default {
  gatsbyDeployToMain,
  gatsbyDeploySelectGhpages,
  gatsbyGithubAction1,
  gatsbyGithubSettings,
  gatsbyGithubDeveloperSettings,
  gatsbyGithubGetPAT1,
  gatsbyGithubGetPAT2,
  gatsbyGithubGetPAT3,
  gatsbyGithubGetPAT4,
  gatsbyGithubGetPAT5,
  gatsbyGithubDeployYml,
  gatsbyGithubAutoDeploy,
  React
};